import { render, staticRenderFns } from "./SemanticSearch.vue?vue&type=template&id=9a3d87a4&lang=html"
import script from "./SemanticSearch.vue?vue&type=script&lang=js"
export * from "./SemanticSearch.vue?vue&type=script&lang=js"
import style0 from "./SemanticSearch.vue?vue&type=style&index=0&id=9a3d87a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports